/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Fragment } from "react";

import {
  DropdownToggle,
  DropdownMenu,
  UncontrolledButtonDropdown,
  DropdownItem,
} from "reactstrap";

import { faAngleDown } from "@fortawesome/free-solid-svg-icons";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { userService } from "../../../_services/user.service";
import { api } from "../../../_services/api.service";
import { withRouter } from "react-router-dom";

class UserBox extends React.Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.currentUser = userService.getLoggedInUser();
    this.state = {
      active: false,
      imageUri: "",
    };
  }

  componentDidMount() {
    api.getUserPhotoBase64(this.currentUser.userId).then((uri) => {
      this.setState({ imageUri: uri });
    });
  }

  render() {
    return (
      <Fragment>
        {/* <div className="header-btn-lg pr-0"> */}
        <div className="widget-content p-0">
          <div className="widget-content-wrapper">
            <div className="widget-content-left">
              <UncontrolledButtonDropdown>
                <DropdownToggle color="link" className="p-0">
                  {this.state.imageUri !== undefined &&
                    this.state.imageUri !== null &&
                    this.state.imageUri !== "" && (
                      <img
                        width={42}
                        height={42}
                        className="rounded-circle"
                        src={`data:image/jpeg;base64,${this.state.imageUri}`}
                        alt="avatar"
                      />
                    )}
                  <div style={{ display: "inline-block" }}>
                    {this.currentUser !== null &&
                      (this.state.imageUri == undefined ||
                        this.state.imageUri == null ||
                        this.state.imageUri == "") &&
                      this.currentUser.firstName !== undefined &&
                      this.currentUser.lastName !== undefined && (
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: 20,
                            borderWidth: 1,
                            borderColor: "white",
                            borderStyle: "solid",
                            alignContent: "center",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <div
                            style={{
                              fontSize: 20,
                              textAlign: "center",
                              color: "white",
                            }}
                          >
                            {this.currentUser.firstName.charAt(0) +
                              this.currentUser.lastName.charAt(0)}
                          </div>
                        </div>
                      )}
                  </div>
                  <FontAwesomeIcon
                    className="ml-2 opacity-8"
                    icon={faAngleDown}
                  />
                </DropdownToggle>
                <DropdownMenu right className="rm-pointers dropdown-menu-lg">
                  <div className="dropdown-menu-header">
                    <div className="dropdown-menu-header-inner">
                      <div className="menu-header-content text-left">
                        <div className="widget-content p-0">
                          <div className="widget-content-wrapper">
                            <DropdownItem>
                              <a
                                href="#"
                                style={{ fontSize: 16, fontWeight: "bold" }}
                                onClick={(e) => {
                                  e.preventDefault();
                                  this.props.history.push({
                                    pathname: `/profile`,
                                  });
                                }}
                              >
                                My Profile
                              </a>
                            </DropdownItem>

                            <DropdownItem>
                              <div className="widget-content-right mr-2">
                                <a
                                  href="#"
                                  style={{ fontSize: 16, fontWeight: "bold" }}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    this.props.history.push({
                                      pathname: `/logout`,
                                    });
                                  }}
                                >
                                  Logout
                                </a>
                              </div>
                            </DropdownItem>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </DropdownMenu>
              </UncontrolledButtonDropdown>
            </div>
            <div className="widget-content-left  ml-3 header-user-info">
              <div className="widget-heading">{this.props.name}</div>
              <div className="widget-subheading">
                {this.currentUser.roleId == 110
                  ? "Admin"
                  : this.currentUser.partnerId > 0
                  ? "Partner"
                  : ""}
              </div>
            </div>
          </div>
        </div>
        {/* </div> */}
      </Fragment>
    );
  }
}

export default withRouter(UserBox);
